import React from "react";

/* Lightweight shimmer skeleton primitives used across public pages while
   data loads. Keeps first-paint visually rich instead of flashing empty
   states or "no results" messages. */

export const SkeletonBlock = ({ className = "", style, testId }) => (
  <div
    className={`bg-black/5 animate-pulse ${className}`}
    style={style}
    data-testid={testId}
  />
);

export const SkeletonLine = ({ w = "100%", h = 14, className = "" }) => (
  <div
    className={`bg-black/5 animate-pulse rounded-sm ${className}`}
    style={{ width: w, height: h }}
  />
);

/* Grid of image tiles — used for /projects, /companies, /media grids. */
export const SkeletonGrid = ({ count = 6, columns = "grid-cols-2 md:grid-cols-3", aspect = "aspect-[4/3]", gap = "gap-4 md:gap-6", testId = "skeleton-grid" }) => (
  <div className={`grid ${columns} ${gap}`} data-testid={testId}>
    {Array.from({ length: count }).map((_, i) => (
      <div key={i}>
        <div className={`${aspect} bg-black/5 animate-pulse`} />
        <div className="mt-4 h-3 w-24 bg-black/5 animate-pulse" />
        <div className="mt-2 h-5 w-3/4 bg-black/5 animate-pulse" />
      </div>
    ))}
  </div>
);

/* List of stacked rows — used for /careers openings list. */
export const SkeletonRows = ({ count = 4, testId = "skeleton-rows" }) => (
  <div className="divide-y divide-black/5 border-t border-b border-black/10" data-testid={testId}>
    {Array.from({ length: count }).map((_, i) => (
      <div key={i} className="py-8 flex items-center justify-between gap-8">
        <div className="flex-1">
          <div className="h-6 w-2/3 bg-black/5 animate-pulse rounded-sm" />
          <div className="mt-3 h-3 w-1/3 bg-black/5 animate-pulse rounded-sm" />
        </div>
        <div className="h-4 w-20 bg-black/5 animate-pulse rounded-sm hidden md:block" />
      </div>
    ))}
  </div>
);
